export default function WeatherReportExportButton({ reportElementId = "weather-intelligence-report" }) {
  const handlePrint = () => {
    const node = document.getElementById(reportElementId);
    if (!node) {
      window.print();
      return;
    }
    window.print();
  };

  return (
    <button type="button" className="weather-btn weather-btn-secondary" onClick={handlePrint}>
      Print report
    </button>
  );
}
